import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentUserAsAvailable } from '@user/shared/current-user';
import { useUserDescription, useUserLinkPreviewTitle } from '@user/shared/use-tdk';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const UserTwitter: FC = () => {
  const user = useAtomValue($CurrentUserAsAvailable);
  const title = useUserLinkPreviewTitle();
  const description = useUserDescription();

  return (
    <DynamicHead>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Lemon8" />
      <meta name="twitter:text:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={user.avatar} />
    </DynamicHead>
  );
};
